import axios from 'axios';

// Public (unauthenticated) instance — branding is readable without a token.
const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/v1',
});

export const getPublicSettings = () =>
  publicApi.get('/settings/public').then((r) => r.data.data);
